<script>
import Api from '../config/api';

export default {
  name: 'Logout',
  created() {
    this.logout();
  },
  methods: {
    //    logout() {
    //       this.axios({
    //        method: 'post',
    //        data: {},
    //        url: Api.url(Api.endpoints.LOGOUT),
    //      });
    //
    //      return this.$auth.logout();
    //    },
    async logout() {
      try {
        const token = await this.$auth.getToken();
        const res = await this.axios({
          method: 'post',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          url: Api.url(Api.endpoints.LOGOUT),
        });

        this.$auth.logout();
      } catch (error) {
        if (error.response.status == 401) {
          this.$auth.logout();
        }
        console.log(error);
      }
    },
  },
};
</script>
